var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 35C7.525 35 6.78125 34.6938 6.16875 34.0813C5.55625 33.4688 5.25 32.725 5.25 31.85V11.9C5.25 11.025 5.55625 10.2813 6.16875 9.66875C6.78125 9.05625 7.525 8.75 8.4 8.75H28.3063C29.2104 8.75 29.9688 9.05625 30.5813 9.66875C31.1938 10.2813 31.5 11.025 31.5 11.9V19.9062L36.2688 15.1375C36.5313 14.875 36.8229 14.8091 37.1438 14.9397C37.4646 15.0716 37.625 15.3271 37.625 15.7063V28.0437C37.625 28.4229 37.4646 28.6778 37.1438 28.8085C36.8229 28.9403 36.5313 28.875 36.2688 28.6125L31.5 23.8438V31.85C31.5 32.725 31.1938 33.4688 30.5813 34.0813C29.9688 34.6938 29.2104 35 28.3063 35H8.4ZM8.4 32.375H28.3063C28.4813 32.375 28.6201 32.3243 28.7228 32.2228C28.8243 32.1201 28.875 31.9958 28.875 31.85V11.9C28.875 11.7542 28.8243 11.6305 28.7228 11.529C28.6201 11.4263 28.4813 11.375 28.3063 11.375H8.4C8.25417 11.375 8.1305 11.4263 8.029 11.529C7.92633 11.6305 7.875 11.7542 7.875 11.9V31.85C7.875 31.9958 7.92633 32.1201 8.029 32.2228C8.1305 32.3243 8.25417 32.375 8.4 32.375ZM7.875 32.375V11.375V32.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoWhite);
export default __webpack_public_path__ + "static/media/video-white.6ee449a96d3d8f081a4d4cc913c9d4d4.svg";
export { ForwardRef as ReactComponent };